/**
    商品列表
**/
<template>
  <div class="rightaside_content">
    <h3 class="headerTitle">发票管理</h3>
    <div class="wholeBox" v-loading="loading">
      <el-row class="getinvoiceList">
        <el-col v-for="(item, index) in addressLists" :key="item.id+'invoice'" class="getaddressItem">
          <div>
            <!-- <div  @click="selectedAddress(index, item.id)"> -->
            <p>
              <strong>发票类型:</strong>
              <span v-if="item.type == '1'">电子发票(非纸质)</span>
              <span v-if="item.type == '2'">普通发票(纸质)</span>
              <span v-if="item.type == '3'">专用发票</span>
            </p>
            <p v-if="item.type != 3"><strong>抬头类型: </strong>
              <span v-if="item.attribution == 1">个人</span>
              <span v-if="item.attribution == 2">单位</span>
            </p>
            <p><strong>抬头名称: </strong> {{ item.invoiceTitle }}</p>
            <p><strong>公司税号: </strong> {{ item.taxpayerNumber }}</p>
            <p><strong>注册地址: </strong> {{ item.address }}</p>
            <p><strong>注册电话: </strong> {{ item.tel }}</p>
            <p><strong>开户银行: </strong> {{ item.bank }}</p>
            <p><strong>银行账号: </strong> {{ item.bankAccount }}</p>
            <p><strong>收票人姓名: </strong> {{ item.invoiceName }}</p>
            <p><strong>收票人手机号: </strong> {{ item.invoiceTel }}</p>
            <p><strong>收票地址: </strong> {{ item.invoiceAddressText }}</p>
            <p><strong>收票详细地址: </strong> {{ item.invoiceAddress }}</p>
		<!-- 	<p>
			  <strong>地址: </strong> {{ item.invoiceAddressText }} &nbsp;
			  <span style="margin-left: 35px">{{ item.address }}</span>
			</p> -->
       
            <p><strong>邮编: </strong> {{ item.postalCode }}</p>

            <div class="addressColor">
			  <span :class="item.falg ==0?'grayBn':''"  @click="changeActive(item)">默认</span>
              <span @click="editAddress(item, 'see')">详情</span>
              <span @click.stop="editAddress(item)" class="edit">修改</span>
              <el-popconfirm confirm-button-span="确定" cancel-button-text="取消" confirm-button-type="danger"
                @confirm="deleteAddress(item.id)" icon="el-icon-info" icon-color="red" title="确定要删除吗？" placement="top"
                class="delete">
                <el-button slot="reference">删除</el-button>
              </el-popconfirm>
            </div>
          </div>

        </el-col>
        <el-col class="getaddressItem addHover">
          <div class="getaddressBox" @click="addAddress()">
            <div class="el-icon-circle-plus addIcon"></div>
            <p class="addText" style="text-align: center">添加发票</p>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 发票的弹框 -->
    <el-dialog :visible.sync="dialogVisible" :destroy-on-close="true" :close-on-click-modal="false" @close="beforeClose"
      width="910px" class="dialogBox">
      <div v-if="showEditButtom==1" class="textCenter">
        添加发票信息
      </div>
      <div v-if="showEditButtom==2 " class="textCenter">
        编辑发票信息
      </div>
	  <div v-if="showEditButtom==3 " class="textCenter">
	    发票信息
	  </div>
      <span slot="footer" class="dialog-footer">
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm"
          v-if="dialogVisible">
          <el-form-item label="发票类型">
            <el-radio-group v-model="ruleForm.type" :disabled="showEditButtom==3">
              <el-radio label="1">电子发票(非纸质)</el-radio>
              <el-radio label="2">普通发票(纸质)</el-radio>
              <el-radio label="3">专用发票</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="抬头类型" v-if="ruleForm.type != 3" >
            <el-radio-group v-model="ruleForm.attribution" :disabled="showEditButtom==3">
              <el-radio label="1">个人</el-radio>
              <el-radio label="2">单位</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="抬头名称" prop="invoiceTitle">
            <el-input type="text" v-model="ruleForm.invoiceTitle" autocomplete="off" :disabled="showEditButtom==3"></el-input>
          </el-form-item>
          <el-form-item label="公司税号" prop="taxpayerNumber" v-if="ruleForm.type == 3 || ruleForm.attribution == 2">
            <el-input type="text" v-model="ruleForm.taxpayerNumber" autocomplete="off" :disabled="showEditButtom==3"></el-input>
          </el-form-item>
          <el-form-item label="注册地址" prop="address" v-if="ruleForm.type == 3">
            <el-input type="text" v-model="ruleForm.address" autocomplete="off" :disabled="showEditButtom==3"></el-input>
          </el-form-item>
          <el-form-item label="注册电话" prop="tel" v-if="ruleForm.type == 3">
            <el-input type="text" v-model="ruleForm.tel" autocomplete="off" :disabled="showEditButtom==3"></el-input>
          </el-form-item>
          <el-form-item label="开户银行" prop="bank" v-if="ruleForm.type == 3">
            <el-input type="text" v-model="ruleForm.bank" autocomplete="off" :disabled="showEditButtom==3"></el-input>
          </el-form-item>
          <el-form-item label="银行账号" prop="bankAccount" v-if="ruleForm.type == 3">
            <el-input type="text" v-model="ruleForm.bankAccount" autocomplete="off" :disabled="showEditButtom==3"></el-input>
          </el-form-item>
          <el-form-item label="收票人姓名" prop="invoiceName" v-if="ruleForm.type != 1">
            <el-input type="text" v-model="ruleForm.invoiceName" autocomplete="off" :disabled="showEditButtom==3"></el-input>
          </el-form-item>
          <el-form-item label="收票人手机号" prop="invoiceTel" v-if="ruleForm.type != 1">
            <el-input type="text" v-model="ruleForm.invoiceTel" autocomplete="off" :disabled="showEditButtom==3"></el-input>
          </el-form-item>
          <el-form-item label="收票地址" prop="thsAraeCode" v-if="ruleForm.type != 1">
             <el-cascader
               v-model="ruleForm.thsAraeCode"
               ref="cascaderAddr"
               class="cascaderArea"
               placeholder="收票地址"
               :props="{ checkStrictly: true }"
               :options="getprovince"
               @change="areaHandleChange"
			   :disabled="showEditButtom==3"
             >
             </el-cascader>
          </el-form-item>
          <el-form-item label="收票详细地址" prop="invoiceAddress" v-if="ruleForm.type != 1">
            <el-input type="text" v-model="ruleForm.invoiceAddress" autocomplete="off" :disabled="showEditButtom==3"></el-input>
          </el-form-item>



          <el-form-item>
            <el-button type="primary" size="mini" v-if="showEditButtom ==1" :disabled="comfiremdisabled"
              @click="submintAddress()" class="buttonBgd">确 定</el-button>
            <el-button type="primary" size="mini" v-if="showEditButtom ==2" @click="submintAddress('edit')"
              class="buttonBgd">确 定 修 改</el-button>
          </el-form-item>
        </el-form>
      </span>
    </el-dialog>


    <!-- 发票的弹框 -->
    <el-dialog :visible.sync="dialogInvoice" :destroy-on-close="true" :close-on-click-modal="false"
      @close="invoiceClose" width="910px" class="dialogBox" v-if="dialogInvoice">
      <div class="textCenter">
        发票详情
      </div>
      <span slot="footer" class="dialog-footer">
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm"
          v-if="invoiceData">
          <el-form-item label="发票类型">
            <span v-if="invoiceData.type == '1'">电子发票(非纸质)</span>
            <span v-if="invoiceData.type == '2'">普通发票(纸质)</span>
            <span v-if="invoiceData.type == '3'">专用发票</span>
          </el-form-item>
          <el-form-item label="抬头类型" v-if="invoiceData.type != 3">
            <span v-if="invoiceData.attribution == '1'">个人</span>
            <span v-if="invoiceData.attribution == '2'">单位</span>
          </el-form-item>

          <el-form-item label="抬头名称">
            <el-input type="text" v-model="invoiceData.invoiceTitle" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="公司税号" v-if="invoiceData.type == 3 || invoiceData.attribution == 2">
            <el-input type="text" v-model="invoiceData.taxpayerNumber" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="注册地址" v-if="invoiceData.type == 3">
            <el-input type="text" v-model="invoiceData.address" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="注册电话" v-if="invoiceData.type == 3">
            <el-input type="text" v-model="invoiceData.tel" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="开户银行" v-if="invoiceData.type == 3">
            <el-input type="text" v-model="invoiceData.bank" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="银行账号" v-if="invoiceData.type == 3">
            <el-input type="text" v-model="invoiceData.bankAccount" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="收票人姓名" v-if="invoiceData.type != 1">
            <el-input type="text" v-model="invoiceData.invoiceName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="收票人手机号" v-if="invoiceData.type != 1">
            <el-input type="text" v-model="invoiceData.invoiceTel" autocomplete="off"></el-input>
          </el-form-item>
			<el-form-item label="所在地区"  v-if="invoiceData.type != 1">
				<el-input type="text" v-model="invoiceData.invoiceTel" autocomplete="off"></el-input>
			</el-form-item>
          <el-form-item label="收票详细地址" v-if="invoiceData.type != 1">
            <el-input type="text" v-model="invoiceData.invoiceAddress" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-input type="text" v-model="invoiceData.createTime" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="更新时间" v-if="invoiceData.updateTime">
            <el-input type="text" v-model="invoiceData.updateTime" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
      </span>
    </el-dialog>


  </div>
</template>
<script>
import {
  addresslist,
  address_add,
  address_remove,
  address_saveedit,
  addOrder,
  area_list,
  invoiceList,
  invoiceAdd,
  invoiceDel,
  invoiceDetail,
invoiceDefault,
invoiceEdit,
} from "@/api/xunyou";
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
      loading: false,
      showEditButtom: false,
      dialogVisible: false,
      addressLists: [],
      cascaderAreaValue: [],
      comfiremdisabled: false,
      areaName: "",
      dialogInvoice: false,
      // getprovince:[], // 地址联动
      ruleForm: {
        muid: JSON.parse(localStorage.getItem("userdata")).userId,
        recipient: "",
        phoneNumber: "",
        areaid: "",
        address: "",
        postalCode: "",
        defaultAddress: 0,

        type: "2",
        attribution: "1",
        invoiceTitle: '',
        taxpayerNumber: '',    //税号
        address: '',   //注册地址
        tel: '',
        bankAccount: '',    //银行账号
        bank: '',
        invoiceName: '',   //收票人姓名
        invoiceTel: '',    //收票人手机号
        invoiceAddress: '',   //收票地址
        invoiceData: {},
        id: ''

      },
      rules: {
        recipient: [
          {
            required: true,
            message: "不能为空,请输入",
            trigger: ["blur", "change"],
          },
        ],
        phoneNumber: [
          {
            required: true,
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              if (!/^[1][3,4,5,7,8][0-9]{9}$/.test(value)) {
                callback(new Error('请输入正确的手机号码'));
              } else {
                callback();
              }
            }
          },
        ],
        areaid: [
          {
            required: true,
            message: "不能为空,请输入",
            trigger: ["blur", "change"],
          },
        ],

        invoiceTitle: [
          {
            required: true,
            message: "不能为空,请输入",
            trigger: ["blur", "change"],
          },
        ],
        taxpayerNumber: [
          {
            required: true,
            message: "不能为空,请输入",
            trigger: ["blur", "change"],
          },
        ],
		
        address: [
          {
            required: true,
            message: "不能为空,请输入",
            trigger: ["blur", "change"],
          },
        ],
        tel: [
          {
            required: true,
            message: "不能为空,请输入",
            trigger: ["blur", "change"],
          },
        ],
        bank: [
          {
            required: true,
            message: "不能为空,请输入",
            trigger: ["blur", "change"],
          },
        ],
        bank: [
          {
            required: true,
            message: "不能为空,请输入",
            trigger: ["blur", "change"],
          },
        ],
        bankAccount: [
          {
            required: true,
            message: "不能为空,请输入",
            trigger: ["blur", "change"],
          },
        ],
        invoiceName: [
          {
            required: true,
            message: "不能为空,请输入",
            trigger: ["blur", "change"],
          },
        ],
        recipient: [
          {
            required: true,
            message: "不能为空,请输入",
            trigger: ["blur", "change"],
          },
        ],
        invoiceTel: [
          {
            required: true,
            message: "不能为空,请输入",
            trigger: ["blur", "change"],
          },
        ],
		thsAraeCode: [
		  {
			  type: 'array', 
		    required: true,
		    message: "不能为空,请选择",
		    trigger: ["blur", "change"],
		  },
		],
        // thsAraeCode: [
        //   {
        //     required: true,
        //     message: "不能为空,请输入",
        //     trigger: ["blur", "change"],
        //   },
        // ],


      },
	  defaultType:'true',
	  thsAraeCode: '', //收票人地址
	  invoiceAddress:'',    		//收票人详细地址  
	  invoiceAddressText:'',         //选择地址文字
    };
  },
  // 注册组件
  components: {},
  computed: {
    ...mapState(["getprovince"]),
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() { },
  mounted() {
    this.getinvoiceList();
    //   this.getprovinceList()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
	  
	  // 修改发票默认
	  changeActive(e){
		  console.log(e.id);
		  console.log(this.userInfo.userId);
		  invoiceDefault({ id: e.id,uid:this.userInfo.userId})
		    .then((res) => {
		      if (res.code == 0) {
		        console.log("点击默认",res);
		        this.getinvoiceList();
		      } else {
		        this.$message({
		          type: "info",
		          message: res.msg,
		        });
		      }
		    })
	  },
    isShowAddress() {
      this.areaName = "";
    },

    //   选择收货地址
    selectedAddress(index, id) {
      console.log(id);
      invoiceDefault({ id: id })
        .then((res) => {
          if (res.code == 0) {
            console.log(res.data);
            this.invoiceData = res.data
            this.dialogInvoice = true;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
    },
    invoiceClose() {
      this.invoiceData = {};
      this.dialogInvoice = false;
    },
    //  // 获取省地址
    //     getprovinceList(){
    //         area_list()
    //             .then(res => {
    //             if (res.code == 0) {
    //                 this.getprovince = res.data;
    //             } else {
    //                 this.$message({
    //                 type: 'info',
    //                 message: res.msg
    //                 })
    //             }
    //             })
    //             .catch(err => {
    //             this.editFormVisible = false
    //             this.loading = false
    //             this.$message.error('获取地址失败，请稍后再试！')
    //             })
    //     },
    // 填写地址选择
    areaHandleChange(value, form, thsAraeCode) {
      // this.$refs["cascaderAddr"].getCheckedNodes();
      // this.ruleForm.areaid = value[value.length - 1];
      // this.thsAraeCode = this.$refs['cascaderAddr'].currentLabels;
	  this.invoiceAddressText = String(this.$refs['cascaderAddr'].getCheckedNodes()[0].pathLabels)
	  	.replace(/,/g, '/')
		// invoiceAddressCode
		// this.ruleForm.invoiceAddressCode = this.cascaderAreaValue;
		console.log('填写地址选择',this.invoiceAddressText,this.ruleForm.thsAraeCode);
		console.log(this.cascaderAreaValue,this.thsAraeCode,'填写地址选择');
    },
    // 新增
    addAddress() {
		this.showEditButtom = 1;
      this.dialogVisible = true;
    },
    //   关闭弹框清空
    beforeClose() {
      this.ruleForm = {};
      this.cascaderAreaValue = [];
      this.showEditButtom = false;
    },
	
    //   确定新增发票
    submintAddress(item) {
      //   console.log(editReq,'xiugai1')
      if (item == "edit") {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            let editReq = {
              invoiceTitle: this.ruleForm.invoiceTitle,
              taxpayerNumber: this.ruleForm.taxpayerNumber,
              address: this.ruleForm.address,
              phoneNumber: this.ruleForm.invoiceTel,
              tel: this.ruleForm.tel,
              bank: this.ruleForm.bank,
              bankAccount: this.ruleForm.bankAccount,
              invoiceName: this.ruleForm.invoiceName,
              invoiceTel: this.ruleForm.invoiceTel,
              invoiceAddress: this.ruleForm.invoiceAddress,
			  
			  invoiceAddressCode:this.ruleForm.thsAraeCode,
			  invoiceAddressText:this.invoiceAddressText,
              type: this.ruleForm.type,
              attribution: this.ruleForm.attribution,
              id: this.ruleForm.id,

            };
            invoiceEdit(editReq)
              .then((res) => {
                if (res.code == 0) {
                  this.showEditButtom = false;
                  this.dialogVisible = false;
                  this.ruleForm = {};
                  this.cascaderAreaValue = [];
                  this.getinvoiceList();
                } else {
                  this.$message({
                    type: "info",
                    message: res.msg,
                  });
                }
              })
              .catch((err) => {
                this.dialogVisible = false;
                this.$message.error("修改失败，请稍后再试！");
              });
          }
        });
      } else {
        this.$refs.ruleForm.validate((valid) => {
          this.ruleForm.muid = this.userInfo.userId;
          this.ruleForm.uid = this.userInfo.userId;
          this.ruleForm.defaultAddress = this.ruleForm.defaultAddress ? 1 : 0;
          if (valid) {
            this.comfiremdisabled = true;
            invoiceAdd(this.ruleForm)
              .then((res) => {
                if (res.code == 0) {
                  this.dialogVisible = false;
                  this.ruleForm = {};
                  this.getinvoiceList();
                  this.comfiremdisabled = false;
                  this.$message({
                    type: "info",
                    message: res.msg,
                  });
                } else {
                  this.$message({
                    type: "info",
                    message: res.msg,
                  });
                  this.comfiremdisabled = false;
                }
              })
              .catch((err) => {
                this.dialogVisible = false;
                this.$message.error("提交失败，请稍后再试！");
              });
          }
        });
      }
    },

    //   删除地址
    deleteAddress(deleteId) {
      invoiceDel({ ids: deleteId })
        .then((res) => {
          if (res.code == 0) {
            this.getinvoiceList();
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error("删除失败，请稍后再试！");
        });
    },
    // 查看，修改地址
    editAddress(item,e) {
      console.log(item);
      this.areaName = item.areaName;
	  var str =item.thsAraeCode;
	  if(str){
		  str = str.split(",");
		  str.forEach((item,index) =>{
		  	str[index] = parseInt(str[index])
		  })
	  }
	 
	  if(e == 'see'){
		   this.showEditButtom = 3;
	  }else{
		  this.showEditButtom = 2;
	  }
      this.ruleForm = {
        type: item.type + '',
        attribution: item.attribution,
        invoiceTitle: item.invoiceTitle,
        taxpayerNumber: item.taxpayerNumber,
        address: item.address,
        tel: item.tel,
        bank: item.bank,
        bankAccount: item.bankAccount,
        bankAccount: item.bankAccount,
        invoiceName: item.invoiceName,
        invoiceTel: item.invoiceTel,
        thsAraeCode: str,
        invoiceAddress: item.invoiceAddress,
        id: item.id
      };
      console.log(this.ruleForm);

      this.dialogVisible = true;
     

    },
    // 发票查询
    getinvoiceList() {
      this.loading = true;
      invoiceList({ uid: this.userInfo.userId })
        .then((res) => {
          if (res.code == 0) {
            this.loading = false;
            this.addressLists = res.rows;
            //   this.envelopeList = res.rows;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.editFormVisible = false;
          this.loading = false;
          this.$message.error("查询收货失败，请稍后再试！");
        });
    },
  },
};
</script>

<style scoped lang="less">
.rightaside_content {
  .headerTitle {
    font-size: 20px;
    height: 40px;
    line-height: 40px;
    color: #666;
  }

  .wholeBox {
    .infoBox {
      .textRedColor {
        color: #ff6700;
      }
    }

    .getinvoiceList {
      width: 100%;
      margin: 20px 0;
      display: block;
      justify-content: flex-start;
      flex-wrap: wrap;

      .addHover:hover {
        cursor: pointer;
        color: #ff6700;
      }

      .defaultAddressColor {
        color: #ff6700;
        position: absolute;
      }

      .getaddressItem {
        border: 1px solid #ccc;
        display: block;
        padding: 20px;
        box-sizing: border-box;
        margin: 2px;

        p {
          display: inline-block;
          width: 49%;
          line-height: 30px;
        }

        .getaddressBox {
          position: relative;
          top: 40%;
          left: 50%;
          transform: translate(-50%, -45%);
        }

        .addIcon {
          font-size: 30px;
          text-align: center;
          display: block;
          margin-bottom: 10px;
          margin-top: 65px;
        }

        .addText {
          display: block;
          width: 100%;
        }

        .addressColor {
          text-align: right;
          position: relative;
          bottom: -20px;
          color: #ff6700;
          cursor: pointer;
          font-size: 14px;

          span {
            display: inline-block;
            margin-left: 20px;
            border: 1px solid;
            padding: 5px 20px;
            margin-bottom: 10px;
            border-radius: 10px;
          }
					.grayBn{
						border-color:#999;
						color:#999;
					}

          .delete {
            /deep/button.el-button.el-button--default.el-popover__reference {
              border: 0px;
              color: #ff6700;
              padding: 0;
            }

            /deep/.el-button:focus,
            .el-button:hover {
              background: transparent;
            }
          }
        }
      }
    }
  }

  button.el-button.buttonBgd.el-button--primary {
    background-color: #ff6700;
    border-color: #ff6700;
    font-size: 14px;
    margin-bottom: 20px;
  }

  .cascaderArea.el-cascader {
    width: 100%;

    /deep/input[disabled],
    /deep/input[disabled="disabled"],
    /deep/input[readonly],
    /deep/input[readonly="readonly"] {
      background-color: white;
    }
  }
}

.addressCss {
  display: flex;
  justify-content: space-between;

  .editCss {
    color: #ff6700;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/myOrder/myCenter/invoiceList.vue